<template>
  <div id="upload-file" class="position-relative w-100 h-100">
    <div class="font-22px">Import File</div>
    <div class="upload-file-wrp px-2 mb-1">
      <div class="upload-file-inner font-22px w-100 h-100">
        <div v-if="csvFile">{{ csvFile.name }}</div>
        <div class="d-flex" v-else>
          <div class="mr-1">Upload File or</div>
          <div class="mr-1 underlined">
            <b-link class="underlined" @click="onDownloadtTemplate"
              >Click Here</b-link
            >
          </div>
          <div>to Download Template</div>
        </div>
      </div>
    </div>
    <div class="d-flex align-item-center justify-content-end">
      <button class="upload-file-button button mr-2" @click="onUploadFile">
        <input
          type="file"
          ref="file"
          class="d-none"
          @change="handleUploadFile($event)"
          :accept="acceptFile.toString()"
        />
        <div class="d-flex align-items-center">
          <span>Upload File</span>
        </div>
      </button>
      <button
        class="import-file-button button"
        :class="!csvFile ? 'disable-btn-import' : ''"
        @click="$emit('onImportFile', csvFile)"
      >
        Import
      </button>
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from "@vue/composition-api";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  props: {
    TemplateCSV: { type: String, default: "" },
    acceptFile: {
      type: [String, Array],
      default: () => [".csv", ".xls", ".xlsx"],
    },
  },
  setup(props) {
    const { openErrorModal } = useValidationModal();

    const vm = getCurrentInstance().proxy;

    const csvFile = ref(null);

    const onDownloadtTemplate = () => {
      if (!props.TemplateCSV) return;
      window.location.href = props.TemplateCSV;
    };

    const handleUploadFile = (event) => {
      const file = event.target.files[0];

      const _validFileExtensions = props.acceptFile;

      const fileName = file.name;
      if (fileName.length > 0) {
        var isValidExtension = false;
        var fileExtension = null;

        for (var i = 0; i < _validFileExtensions.length; i++) {
          var curExtension = _validFileExtensions[i];
          fileExtension = fileName
            .substr(fileName.length - curExtension.length, curExtension.length)
            .toLowerCase();

          if (fileExtension == curExtension.toLowerCase()) {
            isValidExtension = true;
            csvFile.value = file;
            break;
          }
        }

        if (!isValidExtension) {
          openErrorModal(
            "อัพโหลดไฟล์ไม่ถูกต้อง",
            "<div>กรุณาอัพโหลดไฟล์ใหม่อีกครั้ง</div>" +
              "<div class='text-bold'>นามสกุลไฟล์ที่รองรับ " +
              _validFileExtensions.join(", ") +
              "</div>",
            "ปิด"
          );
          return (csvFile.value = null);
        }
      }
    };

    const onUploadFile = () => {
      vm.$refs.file.click();
    };

    return {
      onDownloadtTemplate,
      csvFile,
      handleUploadFile,
      onUploadFile,
    };
  },
};
</script>

<style scoped>
#upload-file .upload-file-wrp {
  width: 100%;
  height: 60px;
  border: 1px solid #000000;
  border-radius: 10px;
  margin-top: 5px;
}

#upload-file .upload-file-inner {
  display: flex;
  align-items: center;
}

#upload-file .underlined {
  text-decoration: underline;
  color: #3c78d8;
  cursor: pointer;
}

#upload-file .button {
  width: 90px;
  height: 36px;
  border-radius: 0.6rem;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#upload-file .upload-file-button {
  background-color: #fff;
  border: 1px solid #38761d;
  color: #000;
}

#upload-file .import-file-button {
  background-color: #6aa84fff;
  border: 1px solid #595959;
  color: #fff;
}

#upload-file .disable-btn-import {
  background-color: #eeeeeeff;
  border: 1px solid #595959;
  color: #000;
  cursor: no-drop;
}

#upload-file .font-22px {
  font-size: 22px;
}
</style>